import type { SamlIdentityProvider } from '@repo/api-gw-sdk';

import { UpsertSamlStep } from './upsertSamlStep';

import type { Step } from '../wizard/Step';

export type UpsertSamlState = SamlIdentityProvider;

export const UpsertSamlFlow: Step<UpsertSamlState> = {
  id: 'upsert_saml',
  Component: UpsertSamlStep,
};
